<script lang="ts">
import type { ImageCard } from '$types/card';
import RichText from './RichText.svelte';

interface Props {
  card: ImageCard;
  revealed: boolean;
  occlusionIndex: number;
}

const { card, revealed, occlusionIndex }: Props = $props();
const occlusions = $derived(card.image.occlusions ?? []);
const activeOcclusion = $derived(occlusions[occlusionIndex % Math.max(1, occlusions.length)]);
</script>

<div class="card-image">
  {#if card.front}<div class="card-text"><RichText content={card.front} /></div>{/if}
  <div class="img-frame">
    <div class="img-placeholder">
      <img src={card.image.src} alt={card.front ?? 'Schema-Abbildung zum Beschriften'} />
      {#each occlusions as o, i}
        {#if !revealed && (!activeOcclusion || activeOcclusion.id === o.id)}
          <div class={revealed ? 'occ occ-on' : 'occ occ-off'} style:left="{o.x}%" style:top="{o.y}%" style:width="{o.w}%" style:height="{o.h}%">
            <span class="occ-num">{i + 1}</span>
          </div>
        {:else if revealed}
          <div class="occ occ-on" style:left="{o.x}%" style:top="{o.y}%" style:width="{o.w}%" style:height="{o.h}%">
            <span class="occ-answer">{o.label}</span>
          </div>
        {/if}
      {/each}
    </div>
  </div>
  {#if revealed && card.back}
    <div class="card-back">
      <div class="back-label">↳ legende</div>
      <div class="back-body"><RichText content={card.back} /></div>
    </div>
  {/if}
</div>

<style>
  .card-text {
    font-family: var(--font-body), 'Inter', system-ui, sans-serif;
    font-size: 20px;
    line-height: 1.35;
    color: var(--ink);
    font-weight: 500;
    letter-spacing: -0.01em;
  }
  .card-image { display: flex; flex-direction: column; gap: 12px; }
  .img-frame {
    border: 1px solid var(--rule);
    background: var(--paper-2);
    padding: 4px;
  }
  .img-placeholder { position: relative; width: 100%; aspect-ratio: 5 / 3; color: var(--ink-3); background: var(--paper); }
  .img-placeholder img { display: block; max-width: 100%; height: auto; }
  .occ {
    position: absolute;
    border: 2px solid var(--ink);
    display: flex; align-items: center; justify-content: center;
    font-family: var(--font-mono);
    font-weight: 700;
  }
  .occ-off { background: var(--accent); color: #fff; }
  .occ-on { background: var(--paper); color: var(--ink); border-color: var(--accent); }
  .occ-num { font-size: 14px; }
  .occ-answer { font-size: 11px; padding: 0 4px; text-align: center; }

  .card-back {
    margin-top: 8px;
    padding: 12px;
    background: var(--paper-2);
    border-left: 4px solid var(--accent);
  }
  .back-label {
    font-size: 10px;
    letter-spacing: 0.12em;
    color: var(--accent-2);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .back-body {
    font-family: var(--font-body), 'Inter';
    font-size: 14px;
    line-height: 1.55;
    color: var(--ink-2);
  }
</style>
